// Copyright (c) 2015, LucrumERP Pvt. Ltd. and Contributors
// License: GNU General Public License v3. See license.txt

if(!window.lucrum) window.lucrum = {};

lucrum.subscribe_to_newsletter = function(opts, btn) {
	return ducky.call({
		type: "POST",
		method: "ducky.email.doctype.newsletter.newsletter.subscribe",
		btn: btn,
		args: {"email": opts.email},
		callback: opts.callback
	});
}
